// Dispara la descarga de un Blob ya obtenido (p. ej. la respuesta binaria de
// un reporte Excel) creando un <a> temporal — es el truco estándar del
// navegador para "guardar como" sin que el usuario tenga que hacer nada más.
export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}

// El backend manda el nombre de archivo sugerido en el header
// Content-Disposition (attachment; filename="reporte-...xlsx"). Si por algo
// no viene, se usa un nombre de respaldo.
export function extractFilenameFromDisposition(disposition) {
  if (!disposition) return null
  const match = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(disposition)
  return match ? decodeURIComponent(match[1]) : null
}

// Cuando axios pide responseType: 'blob' y el backend responde un error (4xx/5xx)
// con JSON, esa respuesta igual llega como Blob — hay que leerla como texto y
// parsearla para no perder el mensaje real del backend.
export async function extractBlobErrorMessage(error) {
  const data = error?.response?.data
  const isJsonBlob = data instanceof Blob && (data.type || '').includes('json')

  if (isJsonBlob) {
    try {
      const text = await data.text()
      const parsed = JSON.parse(text)
      if (parsed?.message) return parsed.message
    } catch {
      // Si no se pudo leer/parsear, se sigue con el mensaje genérico de abajo.
    }
  }

  return error?.response?.data?.message || error?.message || 'Ocurrió un error al generar el reporte.'
}
